import { useItems } from '@findify/react-connect/lib'
import React from 'react'
import { Item } from '../Item'

const SearchItems = () => {

    const { items } = useItems()

    return (
        <div className="row">
            {items.slice(0, 6).map((item) => (
                <div key={item.hashCode()} className="col-xs-12 col-md-2">
                    <Item item={item} />
                </div>
            ))}
        </div>
    )
}

export default SearchItems